export const filterProjects = (input, option) =>
  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

export const findDeal = ({ project, filteredDeals }) =>
  filteredDeals.find(item => item.project_id === Number(project));
